import PropTypes from "prop-types";
import fullScreen from "styles/images/icons-video/Full-screen.svg";
import { translate } from "constants";

export const FullScreen = ({
  buttons,
  locale,
  isFullScreen,
  setIsFullScreen,
  wrapperRef,
  videoRef,
}) => {
  const handleFullScreen = () => {
    setIsFullScreen((val) => !val);
    if (document?.fullscreenElement) {
      setIsFullScreen(false);
      document?.exitFullscreen();
    } else {
      if (wrapperRef.requestFullscreen) {
        wrapperRef.requestFullscreen();
      } else if (wrapperRef.webkitRequestFullscreen) {
        wrapperRef.webkitRequestFullscreen();
      }
      // else if(videoRef.webkitEnterFullscreen){
      //   videoRef.webkitEnterFullscreen()
      // }
      //wrapperRef.requestFullscreen();
      //setIsFullScreen(true);
    }
  };

  return (
    <>
      {buttons.fullScreen && (
        <button
          className={"btn_default hide_on_mobile"}
          onClick={handleFullScreen}
        >
          {isFullScreen
            ? translate("NORMALSCREEN", locale)
            : translate("FULLSCREEN", locale)}
        </button>
      )}
      {buttons.fullScreen && (
        <button
          className={"btn_default hide_on_web"}
          onClick={handleFullScreen}
        >
          <img src={fullScreen} alt={"Fullscreen"} />
        </button>
      )}
    </>
  );
};

FullScreen.propTypes = {
  buttons: PropTypes.shape({
    fullScreen: PropTypes.bool.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  setIsFullScreen: PropTypes.func.isRequired,
  wrapperRef: PropTypes.object.isRequired,
  videoRef: PropTypes.object,
};
